import React, { useContext } from 'react';
import './RoomTypesSection.css';
import { Link } from 'react-router-dom';
import roomsData from "../data/rooms.json"
import RoomCard from './RoomCard';
import { useRef } from 'react';
import { LanguageContext } from '../context/LanguageContext';


const RoomTypesSection = () => {
  const carruselRef = useRef();
  const { t } = useContext(LanguageContext);

  const scrollLeft = () => {
    carruselRef.current.scrollBy({
      left: -carruselRef.current.offsetWidth,
      behavior: "smooth"
    });
  };

  const scrollRight = () => {
    carruselRef.current.scrollBy({
      left: carruselRef.current.offsetWidth,
      behavior: "smooth"
    });
  };

  return (
    <section className="room-types-section">
      <div className="room-types-header">
        <h2 className="room-types-title">{t("roomTypes", "title")}</h2>
        <p className="room-types-description">
          {t("roomTypes", "subtitle")}
        </p>
      </div>
      <div className='rooms-carrusel-wrapper'>
        <button className="btn-left" onClick={scrollLeft}>
          <span class="material-symbols-outlined notranslate"> arrow_back_ios </span>
        </button>
        <div className="rooms-carrusel" ref={carruselRef}>
          {roomsData.data.map((room, index) => (
            <div key={index} className="room-carr-container">
              <RoomCard key={room.id} room={room} />
            </div>
          ))}
        </div>
        <button className="btn-right" onClick={scrollRight}>
          <span class="material-symbols-outlined notranslate"> arrow_forward_ios </span>
        </button>
      </div>
    </section>
  );
};

export default RoomTypesSection;